import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { routeMap } from '../../utils/routeMap';
import { getDomainFromHost } from '../../utils/getDomain';

const SeoLinks = ({ pageId }) => {
  if (typeof window !== 'undefined') {
    window.__PAGE_ID__ = pageId;
  }

  if (!routeMap[pageId]) {
    console.warn(`SEO ERROR: pageId "${pageId}" does not exist in routeMap`);
    return null;
  }

  const currentDomain = getDomainFromHost();

  const langMap = {
    'com.br': 'pt-BR',
    pt: 'pt-PT',
    us: 'en-US',
    co: 'en-US',
  };

  const currentLang = langMap[currentDomain] || 'en-US';

  const urlBR = routeMap[pageId]['com.br'];
  const urlPT = routeMap[pageId]['pt'];
  const urlUS = routeMap[pageId]['us'];
  const urlCO = routeMap[pageId]['co'];

  const canonical =
    routeMap[pageId][currentDomain] ||
    routeMap[pageId]['us'];

  return (
    <Helmet htmlAttributes={{ lang: currentLang }}>
      <link rel="alternate" href={urlBR} hrefLang="pt-BR" />
      <link rel="alternate" href={urlPT} hrefLang="pt-PT" />
      <link rel="alternate" href={urlUS} hrefLang="en-US" />
      <link rel="alternate" href={urlCO} hrefLang="en" />
      <link rel="alternate" href={urlUS} hrefLang="x-default" />

      <link rel="canonical" href={canonical} />
    </Helmet>
  );
};

SeoLinks.propTypes = {
  pageId: PropTypes.string.isRequired,
};

export default SeoLinks;
